import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  listarPresentaciones, crearPresentacion, editarPresentacion, eliminarPresentacion,
  type EntradaPresentacion,
} from '../lib/api/presentaciones';
import { qk } from './keys';

export function usePresentaciones() {
  return useQuery({ queryKey: qk.presentaciones, queryFn: listarPresentaciones });
}

export function useCrearPresentacion() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: EntradaPresentacion) => crearPresentacion(input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: qk.presentaciones });
      qc.invalidateQueries({ queryKey: qk.movimientos });
      qc.invalidateQueries({ queryKey: qk.dashboard });
    },
  });
}

export function useEditarPresentacion() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: EntradaPresentacion }) => editarPresentacion(id, input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: qk.presentaciones });
      qc.invalidateQueries({ queryKey: qk.movimientos });
    },
  });
}

export function useEliminarPresentacion() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => eliminarPresentacion(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: qk.presentaciones });
      qc.invalidateQueries({ queryKey: qk.inventario });
      qc.invalidateQueries({ queryKey: qk.movimientos });
      qc.invalidateQueries({ queryKey: qk.dashboard });
    },
  });
}
